
export const getFormatterCount = (count, step) => Math.round((count * (step || 1)) * 100) / 100
